import type { SVGProps } from 'react';
import { CheckBoldIcon } from '@zep-us/zus/icons';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { LmsO } from '@/icons/components/LmsO';
import { useIsOXLocale } from '@/shared/hooks';
type Props = SVGProps<SVGSVGElement> & {
  color?: string;
};
export const AnswerIconO = ({
  color,
  ...props
}: Props) => {
  const isOXLocale = useIsOXLocale();
  if (isOXLocale) return <LmsO color={color} {...props} />;
  return <CheckBoldIcon fill={color ?? ICON_COLOR.positive} {...props} data-sentry-element="CheckBoldIcon" data-sentry-component="AnswerIconO" data-sentry-source-file="AnswerIconO.tsx" />;
};